export default __webpack_public_path__ + "static/media/MF.38e7be6f.ico";